import { rejected, resolved } from 'store/createAction';
import {
  GET_CONNECTIONS,
  LOAD_ACCOUNT,
  LOAD_ACCOUNT_USAGE,
  LOAD_BRANDS,
  LOAD_FEATURES,
  LOAD_UPCOMING_INVOICE,
  UPDATE_ACCOUNT,
  UPDATE_CONNECTION,
} from '../types';

const initialState = {
  cards: [],
  subscriptions: [],
  upcomingInvoice: undefined,
  usage: undefined,
  features: undefined,
  brands: [],
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case resolved(UPDATE_ACCOUNT):
    case resolved(LOAD_ACCOUNT): {
      return {
        ...state,
        ...payload,
      };
    }
    case resolved(LOAD_ACCOUNT_USAGE): {
      return {
        ...state,
        usage: payload,
      };
    }
    case resolved(LOAD_UPCOMING_INVOICE): {
      return {
        ...state,
        upcomingInvoice: payload,
      };
    }
    case resolved(GET_CONNECTIONS): {
      return {
        ...state,
        connections: payload,
      };
    }
    case resolved(UPDATE_CONNECTION): {
      return {
        ...state,
        connections: state.connections.map((c) =>
          c.conn_id === payload.conn_id ? payload : c,
        ),
      };
    }
    case resolved(LOAD_FEATURES): {
      return {
        ...state,
        features: payload,
      };
    }
    case resolved(LOAD_BRANDS): {
      return {
        ...state,
        brands: payload,
      };
    }
    default:
      return state;
  }
};
